import {
  faDrawPolygon,
  faPencil,
  faUpload,
  faVectorSquare,
} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import IconButton from "../../@ui/IconButton";
import { SearchBar } from "../subheader/SearchBar";
import { useBoundarySelectContext } from "./BoundarySelectContext";
import { ToolsType } from "../../constant/ToolsType";
import { ButtonGroup } from "react-bootstrap";
import { useAuthContext } from "../auth/AuthContext";

const ToolsContainer = styled.div`
  > * {
    margin-left: 10px;
    marging-right: 10px;
  }
`;

const BoundaryTools = () => {
  const {
    addBoundary,
    activeTool,
    setActiveTool,
  } = useBoundarySelectContext();
  const authContext = useAuthContext();
  const isLoggedIn = !!authContext.user;

  const toggleActiveTool = (toolType: ToolsType) => {
    if (activeTool === toolType) {
      setActiveTool(ToolsType.NONE);
    } else {
      setActiveTool(toolType);
    }
  };

  return (
    <ToolsContainer className="d-flex">
      <SearchBar onChange={(b) => addBoundary(b)} />
      <ButtonGroup>
        <IconButton
          className="btn-sm"
          title="Draw polygon"
          icon={faDrawPolygon}
          onClick={() => toggleActiveTool(ToolsType.DRAW_POLYGON)}
          active={activeTool === ToolsType.DRAW_POLYGON}
        />
        <IconButton
          className="btn-sm"
          title="Freehand draw polygon"
          icon={faPencil}
          onClick={() => toggleActiveTool(ToolsType.DRAW_FREEHAND_POLYGON)}
          active={activeTool === ToolsType.DRAW_FREEHAND_POLYGON}
        />
        <IconButton
          className="btn-sm"
          title="Draw square"
          icon={faVectorSquare}
          onClick={() => toggleActiveTool(ToolsType.DRAW_SQUARE)}
          active={activeTool === ToolsType.DRAW_SQUARE}
        />
        <IconButton
          className="btn-sm"
          title="Upload area"
          icon={faUpload}
          onClick={() => toggleActiveTool(ToolsType.UPLOAD_AREA)}
          active={activeTool === ToolsType.UPLOAD_AREA}
        />
      </ButtonGroup>
    </ToolsContainer>
  );
};

export default BoundaryTools;
